import React from 'react';
import { Text } from 'src/@vymo/ui/atoms';
import { ReactComponent as ErrorStateIcon } from 'src/assets/images/errorState.svg';
import { Keys, locale } from 'src/i18n';
import styles from '../index.module.scss';

function ErrorState() {
  return (
    <div className={styles.errorState}>
      <ErrorStateIcon />
      <Text type="h6">{locale(Keys.FACING_ERROR)}</Text>
      <Text>{locale(Keys.SERVER_ERROR_MESSAGE)}</Text>
    </div>
  );
}
export default ErrorState;
